export default __webpack_public_path__ + "static/media/room-e.fc32ecd5.jpg";